export default "__VITE_ASSET__jh59Fh2f__"